import React from 'react';
import { Formik, Form as FForm } from 'formik';
import PropTypes from 'prop-types';

export const FormContext = React.createContext({ readOnly: null, required: null });

export const Form = ({ values, onSubmit, validationSchema, children, config }) => {
  return (
    <FormContext.Provider value={config}>
      <Formik initialValues={values} onSubmit={onSubmit} validationSchema={validationSchema} enableReinitialize={true}>
        <FForm>{children}</FForm>
      </Formik>
    </FormContext.Provider>
  );
};
Form.defaultProps = {
  values: {},
  onSubmit: (values) => console.log(values),
};

Form.propTypes = {
  values: PropTypes.object,
  onSubmit: PropTypes.func,
  validationSchema: PropTypes.any,
};

export default Form;
